import { LoadingSpinner } from '@paypalcorp/pp-react'
import React from 'react'

import { useCommonUIContext } from '../../contexts/common-ui-context'
import './page-loader-v2.less'

function PageLoaderV2() {
  const { isLoader } = useCommonUIContext()
  if (!isLoader) {
    return null
  }
  return (
    <div className="hc_page_loader_v2">
      <LoadingSpinner screenReaderText="loading" size="xl" />
    </div>
  )
}

export default PageLoaderV2
